"use client";

import { useState } from "react";

import { Button } from "@acme/ui/button";
import { Input } from "@acme/ui/input";
import { toast } from "@acme/ui/toast";

export default function EmailReminder() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    setIsLoading(true);
    e.preventDefault();

    try {
      const res = await fetch(
        "https://hook.us1.make.com/9cyfr9lvw2jwkjlbvrwluenhn736ogzu",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        },
      );

      if (res.ok) {
        toast.success("Awesome! You’re on the list.");
        setEmail("");
      } else {
        toast.error("Hmm, something went wrong. Try again?");
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again in a moment.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full max-w-xs">
      <p className="text-muted-foreground mb-3 text-center text-sm">
        <b>Get a Reminder</b> <br /> We'll email you when you're at your desk.
      </p>
      <form onSubmit={handleSubmit} className="flex gap-2">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          className="flex-1"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setEmail(e.target.value)
          }
          required
        />
        <Button type="submit" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Submit"}
        </Button>
      </form>
    </div>
  );
}
